import { render, staticRenderFns } from "./SliderInmuebleDetail.vue?vue&type=template&id=fdfa9ebc&"
import script from "./SliderInmuebleDetail.vue?vue&type=script&lang=js&"
export * from "./SliderInmuebleDetail.vue?vue&type=script&lang=js&"
import style0 from "./SliderInmuebleDetail.vue?vue&type=style&index=0&id=fdfa9ebc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports